export default "__VITE_ASSET__fef1bf8f__"